import { UTILS } from '@aksia/infrastructure';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'camelCase',
  standalone: true,
})
export class CamelCasePipe implements PipeTransform {
  transform(value: string, lowerfirst: boolean = true): string {
    if (typeof value !== 'string') {
      return '';
    }
    return UTILS.STRING.toCamelCase(value, lowerfirst) ?? value;
  }
}
